export enum RegistrationStatus {
  Unknown,
  Registered,
  Pending,
  Unregistered,
  All = 'undefined'
}
